export default __webpack_public_path__ + "static/media/cow-load.f19dcd90.webp";